import { navigate } from "gatsby";
import { isBrowser } from "../utils";

export const redirect = (to, querystring) => {
  if (isBrowser()) {
    querystring ? navigate(to + querystring) : navigate(to);
  }
};
